import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="pad-2xl" style={{ backgroundColor: 'var(--text-primary)', color: 'white' }}>
      <div className="container">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/qubit-logo.svg" 
                alt="Qubit Center Logo" 
                className="w-6 h-6"
                style={{ filter: 'brightness(1) saturate(0) invert(1)' }}
              />
              <span className="heading-3 font-mono">QUBIT CENTER</span>
            </div>
            <p className="body-small opacity-80 mb-4">
              {mockData.siteInfo.description}
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="heading-3 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#curriculum" className="body-small opacity-80 hover:opacity-100 transition-opacity">Curriculum</a></li>
              <li><a href="#features" className="body-small opacity-80 hover:opacity-100 transition-opacity">Features</a></li>
              <li><a href="#testimonials" className="body-small opacity-80 hover:opacity-100 transition-opacity">Reviews</a></li>
              <li><a href="#contact" className="body-small opacity-80 hover:opacity-100 transition-opacity">Contact</a></li>
            </ul>
          </div>
          
          {/* Course Modules */}
          <div>
            <h4 className="heading-3 mb-4">Course Modules</h4>
            <ul className="space-y-2">
              <li className="body-small opacity-80">Electronic Basics</li>
              <li className="body-small opacity-80">Lithium Battery Basics</li>
              <li className="body-small opacity-80">18650 Cell Recycling</li>
              <li className="body-small opacity-80">Battery Pack Building</li>
              <li className="body-small opacity-80">BMS Integration</li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="heading-3 mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 opacity-60" />
                <span className="body-small opacity-80">{mockData.contact.email}</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 opacity-60" />
                <span className="body-small opacity-80">{mockData.contact.phone}</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 opacity-60 mt-1" />
                <span className="body-small opacity-80">{mockData.contact.address}</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="body-small opacity-60">
              © {currentYear} Qubit Center. All rights reserved.
            </div>
            <div className="flex gap-6">
              <a href="#" className="body-small opacity-60 hover:opacity-100 transition-opacity">
                Privacy Policy
              </a>
              <a href="#" className="body-small opacity-60 hover:opacity-100 transition-opacity">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;